// =======================
// CONSTANT NAME
// =======================
export const DEPARTMENT_NAMES = {
  SALES: 'Sales',
  CSO_PROCESSING: 'CSO/Processing',
  COMMERCIAL: 'Commercial',
  PURCHASING: 'Purchasing',
  PRODUCTION: 'Production',
  QC_QA: 'QC/QA',
  DESPATCH_LOADING: 'Despatch Loading',
  DESPATCH_TRANSPORT: 'Despatch Transport',
  CSO_FEEDBACK_COMMERCIAL: 'CSO Feedback - Commercial Supply Only',
  CSO_FEEDBACK_RETAIL: 'CSO Feedback - Trade / Retail',
  COMMERCIAL_FEEDBACK: 'Commercial Feedback - Commercial Supply & Fit',
  COMPLETE: 'Complete'
};

// =======================
// DATA (KHÔNG TRÙNG ID)
// =======================
export const DEPARTMENTS = [
  { id: 4126, name: DEPARTMENT_NAMES.SALES },
  { id: 4128, name: DEPARTMENT_NAMES.CSO_PROCESSING },
  { id: 4129, name: DEPARTMENT_NAMES.COMMERCIAL },
  { id: 4130, name: DEPARTMENT_NAMES.PURCHASING },
  { id: 4131, name: DEPARTMENT_NAMES.PRODUCTION },
  { id: 4132, name: DEPARTMENT_NAMES.QC_QA },
  { id: 4133, name: DEPARTMENT_NAMES.DESPATCH_LOADING },
  { id: 4134, name: DEPARTMENT_NAMES.DESPATCH_TRANSPORT },

  { id: 4135, name: DEPARTMENT_NAMES.CSO_FEEDBACK_COMMERCIAL },
  // { id: 4136, name: DEPARTMENT_NAMES.CSO_FEEDBACK_RETAIL },

  { id: 5554, name: DEPARTMENT_NAMES.COMMERCIAL_FEEDBACK },
  { id: 5445, name: DEPARTMENT_NAMES.COMPLETE }
];

// =======================
// MAP (O(1) lookup)
// =======================
export const DEPARTMENT_MAP = Object.fromEntries(
  DEPARTMENTS.map(d => [d.id, d.name])
);

// =======================
// GET NAME
// =======================
export const getDepartmentName = id => DEPARTMENT_MAP[id] || '';

// =======================
// GET FULL OBJECT
// =======================
export const getDepartment = id =>
  DEPARTMENTS.find(d => d.id === id);

// =======================
// SHOW ALL LIST
// =======================
export const DepartmentWithSelectAll = [
  { id: 4131, name: DEPARTMENT_NAMES.PRODUCTION },
  { id: 4132, name: DEPARTMENT_NAMES.QC_QA },
  { id: 4133, name: DEPARTMENT_NAMES.DESPATCH_LOADING },
  { id: 4134, name: DEPARTMENT_NAMES.DESPATCH_TRANSPORT },
  { id: 4135, name: DEPARTMENT_NAMES.CSO_FEEDBACK_COMMERCIAL },
  { id: 4136, name: DEPARTMENT_NAMES.CSO_FEEDBACK_RETAIL },
  { id: 5554, name: DEPARTMENT_NAMES.COMMERCIAL_FEEDBACK }
];

// =======================
// SHOW ALL SET (O(1))
// =======================
const SELECT_ALL_IDS = new Set(
  DepartmentWithSelectAll.map(d => d.id)
);

// =======================
// CHECK SHOW ALL
// =======================
export const isShowSelectAll = id =>
  SELECT_ALL_IDS.has(id);